// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Image from 'components/Image/Image'

class PostTileVerImageFeature extends React.Component {
	render() {
		let { url, title, excerpt, category, author, date, image, imageAlt, buttonColor } = this.props
		let buttonStyle = buttonColor ? {
			backgroundColor: buttonColor
		} : {}

		return (
			<Link className="post-tile is-vertical is-feature with-image" to={ url }>
				<Image
					thumb={ image.thumb }
					url={ image.url }
					srcset={ image.srcset }
					sizes={ `100vw` }
					alt={ imageAlt }
					focalPoint={ image.focal_point }
					width={ image.width }
					height={ image.height }
				/>

				<div className="-text">
					{ category &&
						<div className="-category">{ category }</div>
					}

					<h3 className="-title">{ title }</h3>

					{ ( author || date ) &&
						<div className="-author-date">
							<div className="-author">{ author }</div>

							{ author && date &&
								<div className="-divider"> | </div>
							}

							<div className="-date">{ date }</div>
						</div>
					}

					{ excerpt &&
						<div className="-excerpt" dangerouslySetInnerHTML={ { __html: excerpt } } />
					}

					<div className="-read" style={ buttonStyle }>Read Now</div>
				</div>
			</Link>
		)
	}
}

export default PostTileVerImageFeature
